import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import './MainLayout.scss'

const MainLayout = () => {
    return (
        <>
            <Container fluid className="mainContainer">
                <Row className="h-100">
                    <Col lg={8} className="d-flex flex-column align-items-center">
                        <Header />
                        <Outlet />
                    </Col>
                    <Col className="bg-logo d-none d-lg-block"></Col>
                </Row>
            </Container>
        </>
    )
}

export default MainLayout